import type { AdmissionState } from "@/api";

export type AdmissionTone = "success" | "warning" | "live" | "neutral";

/**
 * Qabul holatining rangi: ochiq — yashil, to'lish arafasida — sariq,
 * yopiq — qizil, nashr etilmagan/yakunlangan — kulrang. Frontend'dagi
 * `lib/admission` bilan bir xil qoida.
 */
export const admissionTone = (state: AdmissionState, seatsLeft: number | null): AdmissionTone => {
  switch (state) {
    case "OPEN":
      return seatsLeft !== null && seatsLeft <= 3 ? "warning" : "success";
    case "CLOSED":
    case "DEADLINE_PASSED":
    case "FULL":
      return "live";
    default:
      return "neutral";
  }
};
